var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106px",
    height: "157px",
    viewBox: "0 0 106 157",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.23913,0 C103.420771,-5.84457861e-16 106,2.57922916 106,5.76086957 L106,100.23913 C106,103.420771 103.420771,106 100.23913,106 L5.76086957,106 C2.57922916,106 -4.98539846e-16,103.420771 0,100.23913 L0,5.76086957 C-3.89638574e-16,2.57922916 2.57922916,-3.03720559e-16 5.76086957,0 L100.23913,0 Z M52.423913,36.4827118 C46.366016,36.4827118 41.4551202,41.3936076 41.4551202,47.4515046 C41.4551202,51.16458 43.3000697,54.4467443 46.1232601,56.431289 L46.1232601,56.431289 L46.1240214,61.8233276 C46.1240214,63.0959838 47.1557131,64.1276754 48.4283693,64.1276754 L48.4283693,64.1276754 L56.4194568,64.1276754 L56.4194568,64.1276754 L56.5772266,64.1223592 C57.7762962,64.0412828 58.7238046,63.0429564 58.7238046,61.8233276 L58.7238046,61.8233276 L58.7241801,56.4315603 C61.5475883,54.4470434 63.3927059,51.1647492 63.3927059,47.4515046 C63.3927059,41.3936076 58.4818101,36.4827118 52.423913,36.4827118 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4511271,0 C48.6474051,0 62.6203022,13.8009343 62.8980406,30.9310252 L62.9022541,31.4511271 L62.9022541,50.393303 L53.6848628,50.393303 L53.6848628,31.4511271 C53.6848628,19.1717739 43.7304802,9.2173913 31.4511271,9.2173913 C19.3024053,9.2173913 9.4294498,18.9611051 9.22076183,31.0600314 L9.2173913,31.4511271 L9.2173913,50.6956522 L0,50.6956522 L0,31.4511271 C0,14.0811492 14.0811492,0 31.4511271,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VB--404-Copy-4",
    transform: "translate(-678.000000, -321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(678.000000, 321.273171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-15",
    transform: "translate(0.000000, 50.242174)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#506C94",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,4.38188428 C97.0504151,56.6832402 62.933339,90.5559455 3.64877166,106 C19.2919157,106 42.2270393,106 72.4541424,106 L106,106 L106,4.38188428 Z",
    fill: "#3B577E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-17",
    transform: "translate(20.116357, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#3B577E",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M6.40257345,66.6997481 C5.85985225,66.6997481 5.37970897,66.3106273 5.28413543,65.7576661 C5.24886424,65.5574167 4.46379584,60.8128729 7.26614869,57.5281012 C8.97281913,55.530159 11.5806116,54.5368768 15.0087436,54.5892147 C15.6379361,54.598317 16.1396972,55.1148692 16.1305949,55.7440617 C16.1214927,56.3721164 15.5844604,56.8693264 14.9768857,56.8647753 C12.2780709,56.8181263 10.2516842,57.5440301 9.00581476,58.9958378 C6.89523232,61.4568566 7.5198737,65.3321362 7.52670038,65.3719585 C7.63023839,65.9897732 7.21494858,66.5780057 6.5959961,66.6826814 C6.53114263,66.6940592 6.46628915,66.6997481 6.40257345,66.6997481",
    id: "Fill-6",
    fill: "#91A0B4",
    transform: "translate(10.643720, 60.643499) rotate(1.000000) translate(-10.643720, -60.643499) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyLock);
export default __webpack_public_path__ + "static/media/privacy-lock.8fb95f4a9463cb362e7253c217007013.svg";
export { ForwardRef as ReactComponent };